<template>
  <div>

    <Label
      :html-for="id"
      :bold="labelBold"
      v-if="label"
      :disabled="disabled"
    >
      {{ label }}
    </Label>

    <template v-if="busca">
      <vSelect
        :id="id"
        :label="labelBusca"
        :class="inputClass"
        :ref="refBusca"
        :options="options"
        :placeholder="placeholderInField"
        :resetOnOptionsChange="true"
        :disabled="disabled"
        :value="value"
        @input="handleChange"
      >
        <template slot="no-options">
          {{ placeholder }}
        </template>
        <template slot="option" slot-scope="option">
          <slot name="options" :data="option"></slot>
        </template>
        <template slot="selected-option" slot-scope="option">
          <slot name="selected" :data="option"></slot>
        </template>
      </vSelect>
    </template>
    <template v-else>
      <vSelect
        :id="id"
        :label="labelBusca"
        :ref="refBusca"
        :class="inputClass"
        :filterable="filterable"
        :placeholder="placeholderInField"
        :filterBy="filterBy"
        :options="options"
        :resetOnOptionsChange="true"
        :disabled="disabled"
        :value="value"
        @input="handleChange"
        @search="handleSearch"
      >
        <template slot="no-options">
          {{ placeholder }}
        </template>
        <template slot="option" slot-scope="option">
          <slot name="options" :data="option"></slot>
        </template>
        <template slot="selected-option" slot-scope="option">
          <slot name="selected" :data="option"></slot>
        </template>
      </vSelect>
      <div class="input-description input-margin" v-if="description" :class="descriptionClass">
        {{ description }}
      </div>
    </template>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { Label } from '../../../../../../components/Form';

export default {
  name: 'Select',
  components: {
    vSelect,
    Label,
  },
  props: {
    busca: {
      type: Boolean,
      default: false,
    },
    labelBold: {
      type: Boolean,
      default: () => false,
    },
    label: {
      type: String,
      default: null,
    },
    filterBy: {
      type: Function,
    },
    id: {
      type: String,
      requried: true,
    },
    placeholderInField: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
    },
    labelBusca: {
      type: String,
    },
    refBusca: {
      type: String,
    },
    inputClass: {
      type: String,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    change: {
      type: Function,
      required: true,
    },
    search: {
      type: Function,
      required: true,
    },
    options: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: [Object, String],
      default: null,
    },
    description: {
      type: String,
    },
    success: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    handleChange(selected) {
      this.change(selected);
    },
    handleSearch(search, loading) {
      this.search(search, loading);
    },
  },
  computed: {
    descriptionClass() {
      return {
        success: this.success,
        error: this.error,
      };
    },
  },
};
</script>

<style>
.vs--disabled > div {
  border: 2px solid #dedede !important;
  color: #7e7e7e !important;
  background-color: #e9ecef !important;
  opacity: 1;
}

.vs--disabled input {
  background-color: #e9ecef !important;
}
</style>
